<template>
    <b-form-group
        :invalid-feedback="invalidFeedback"
        :label="label"
        :label-for="formControlId"
        v-bind="$attrs">
        <b-form-select
            :id="formControlId"
            v-model="data[property]"
            :disabled="isReadOnlyProperty || dependencyDisabled"
            :name="formControlId"
            :options="internalOptions"
            :required="isRequiredProperty"
            :state="validationState"
            @change="$emit('change')"
            @focus="ensureOptionsLoaded"/>
        <csp-loading-indicator v-if="loadingOptions"/>
    </b-form-group>
</template>

<script>
    import FormGroupMixin from '@components/form/FormGroupMixin'
    import LazySelectOptionsMixin from '@components/form/mixins/LazySelectOptionsMixin'
    import DependentSelectMixin from '@components/form/mixins/DependentSelectMixin'

    export default {
        mixins: [FormGroupMixin, LazySelectOptionsMixin, DependentSelectMixin],
        props: {
            autoSelectSingleOption: {
                type: Boolean,
                default: false,
            },
            defaultValue: {
                type: [String, Number, null],
                default: null,
            },
        },
        emits: ['change'],
        watch: {
            internalOptions: {
                immediate: true,
                handler(newOptions) {
                    if (
                        !this.dependencyDisabled &&
                        this.defaultValue !== null &&
                        Array.isArray(newOptions) &&
                        newOptions.some(o => o.value === this.defaultValue) &&
                        (this.data?.[this.property] === null ||
                            this.data?.[this.property] === undefined ||
                            this.data?.[this.property] === '')
                    ) {
                        // select default option from new options
                        this.$set(this.data, this.property, this.defaultValue);
                        this.$emit('change');
                        return;
                    }

                    if (
                        !this.dependencyDisabled &&
                        this.autoSelectSingleOption &&
                        Array.isArray(newOptions) &&
                        newOptions.length === 1 &&
                        (this.data?.[this.property] === null ||
                            this.data?.[this.property] === undefined ||
                            this.data?.[this.property] === '')
                    ) {
                        // select single option from new options
                        this.$set(this.data, this.property, newOptions[0].value);
                        this.$emit('change');
                    }
                },
            },
        },
    }
</script>
